import produce from 'immer';
import _ from 'lodash';

import { mapFileDetail } from '../../../utils/mappers/files-mapper';

import {
  CLEAR_FORM_EXTERNAL_DETAIL,
  GET_FORM_EXTERNAL_DETAIL_FAILURE,
  GET_FORM_EXTERNAL_DETAIL_IN_PROGRESS,
  GET_FORM_EXTERNAL_DETAIL_SUCCESS
} from './formExternalTypes';

import { LOGOUT } from '../../auth/authReducer';

const initialState = {
  detail: {},
  loadingDetail: false
};

// eslint-disable-next-line default-param-last
const formExternalReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    const { type, ...response } = action;
    const payload = _.getNonEmpty(response, 'response', {});

    switch (type) {
      case GET_FORM_EXTERNAL_DETAIL_IN_PROGRESS:
        draft.loadingDetail = true;
        break;
      case GET_FORM_EXTERNAL_DETAIL_SUCCESS:
        const externalDocumentHeaders = _.get(payload, 'headers');

        draft.detail = mapFileDetail(externalDocumentHeaders);
        draft.loadingDetail = false;
        break;
      case GET_FORM_EXTERNAL_DETAIL_FAILURE:
        draft.loadingDetail = false;
        break;
      case CLEAR_FORM_EXTERNAL_DETAIL:
        draft.detail = initialState.detail;
        break;
      case LOGOUT:
        return initialState;
      default:
    }
  });

export default formExternalReducer;
